var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke: url(#linear-gradient-3);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 2.5,
    x2: 6,
    y2: 2.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f8af2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39defc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 9.5,
    y2: 9.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 7,
    y1: 3.5,
    x2: 13,
    y2: 3.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 7,
    y1: 10.5,
    x2: 13,
    y2: 10.5,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4,.5c.83,0,1.5.67,1.5,1.5v1c0,.83-.67,1.5-1.5,1.5h-2c-.83,0-1.5-.67-1.5-1.5v-1c0-.83.67-1.5,1.5-1.5h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,6.5c.83,0,1.5.67,1.5,1.5v3c0,.83-.67,1.5-1.5,1.5h-2c-.83,0-1.5-.67-1.5-1.5v-3c0-.83.67-1.5,1.5-1.5h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11,.5c.83,0,1.5.67,1.5,1.5v3c0,.83-.67,1.5-1.5,1.5h-2c-.83,0-1.5-.67-1.5-1.5v-3c0-.83.67-1.5,1.5-1.5h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11,8.5c.83,0,1.5.67,1.5,1.5v1c0,.83-.67,1.5-1.5,1.5h-2c-.83,0-1.5-.67-1.5-1.5v-1c0-.83.67-1.5,1.5-1.5h2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationGradient);
export default __webpack_public_path__ + "static/media/Application Gradient.a9a547e9d804e059d6442bdb4aff5a80.svg";
export { ForwardRef as ReactComponent };